import { render } from "./EmailSettingsDialog.vue?vue&type=template&id=6085b28b&scoped=true"
import script from "./EmailSettingsDialog.vue?vue&type=script&lang=js"
export * from "./EmailSettingsDialog.vue?vue&type=script&lang=js"

import "./EmailSettingsDialog.vue?vue&type=style&index=0&id=6085b28b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6085b28b"]])

export default __exports__